import React from 'react';

const FromToDateInput = ({ title, fromDate, toDate, onChangeFrom, onChangeTo, column, period }) => (
  <div className="column">
    <div className="field">
      <div className="label">
        <label htmlFor="" className="label">
          {title}
        </label>
      </div>
      <div className="field-body">
        <div className="field is-expanded">
          <div className="field has-addons">
            <p className="control is-expanded">
              <input
                className="input"
                type={period ? 'month' : 'date'}
                min={'2019-01'}
                placeholder="DD/MM/AAAA"
                value={fromDate}
                onChange={onChangeFrom}
                onKeyDown={(e) => e.preventDefault()}
              />
            </p>
            <p className="control">
              <a className="button is-static" href="/">
                Hasta
              </a>
            </p>
            <p className="control is-expanded">
              <input
                className="input"
                type={period ? 'month' : 'date'}
                min={'2019-01'}
                placeholder="DD/MM/AAAA"
                value={toDate}
                onChange={onChangeTo}
                onKeyDown={(e) => e.preventDefault()}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FromToDateInput;
